(function () {
  if (window.__customCardListenersRegistered) return;
  window.__customCardListenersRegistered = true;

  function getCardImages(card) {
    return card.querySelectorAll('.custom-product-card__image');
  }

  function getCardDots(card) {
    return card.querySelectorAll('.custom-product-card__dot');
  }

  function showImageAtIndex(card, targetIndex) {
    getCardImages(card).forEach((img, i) => {
      img.classList.toggle('hidden', i !== targetIndex);
    });
    getCardDots(card).forEach((dot, i) => {
      dot.classList.toggle('active', i === targetIndex);
    });
  }

  // Hover
  document.addEventListener('mouseover', function (e) {
    const wrapper = e.target.closest('.custom-product-card__image-wrapper');
    if (!wrapper) return;
    const card = wrapper.closest('.custom-product-card');
    if (getCardImages(card).length < 2) return;
    showImageAtIndex(card, 1);
  });

  document.addEventListener('mouseout', function (e) {
    const wrapper = e.target.closest('.custom-product-card__image-wrapper');
    if (!wrapper) return;
    if (wrapper.contains(e.relatedTarget)) return;
    const card = wrapper.closest('.custom-product-card');
    if (getCardImages(card).length < 2) return;
    showImageAtIndex(card, 0);
  });

  // Dots
  document.addEventListener('click', function (e) {
    const dot = e.target.closest('.custom-product-card__dot');
    if (!dot) return;
    e.preventDefault();
    const card = dot.closest('.custom-product-card');
    const index = parseInt(dot.getAttribute('data-dot-index'), 10);
    showImageAtIndex(card, index);
  });

  // Touch / swipe
  let touchStartX = 0;
  let touchEndX   = 0;
  let touchCard   = null;
  let touchMoved  = false;

  document.addEventListener('touchstart', function (e) {
    const wrapper = e.target.closest('.custom-product-card__image-wrapper');
    if (!wrapper) return;
    touchCard   = wrapper.closest('.custom-product-card');
    touchStartX = e.changedTouches[0].screenX;
    touchEndX   = touchStartX;
    touchMoved  = false;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!touchCard) return;
    touchMoved = true;
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (!touchCard) return;
    touchEndX = e.changedTouches[0].screenX;
    const diff = touchStartX - touchEndX;
    if (Math.abs(diff) >= 50) {
      const images = getCardImages(touchCard);
      const currentIndex = [...images].findIndex(img => !img.classList.contains('hidden'));
      const nextIndex = diff > 0
        ? (currentIndex + 1) % images.length
        : (currentIndex - 1 + images.length) % images.length;
      showImageAtIndex(touchCard, nextIndex);
    }
    touchCard = null;
  }, { passive: true });

  document.addEventListener('click', function (e) {
    const link = e.target.closest('.custom-product-card__image-link');
    if (!link) return;
    if (touchMoved && Math.abs(touchStartX - touchEndX) > 30) {
      e.preventDefault();
    }
  });

  // Add to cart
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    const variantId    = btn.getAttribute('data-variant-id');
    const originalText = btn.getAttribute('data-original-text') || btn.textContent.trim();

    btn.disabled = true;
    btn.classList.add('loading');
    btn.textContent = 'ADDING...';

    try {
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });

      if (!addResponse.ok) throw new Error('Failed to add to cart');

      btn.textContent = 'ADDED!';

      const [cartDataRes, cartDrawerRes] = await Promise.all([
        fetch('/cart.js'),
        fetch('/?section_id=cart-drawer')
      ]);

      const cartData       = await cartDataRes.json();
      const cartDrawerHtml = await cartDrawerRes.text();

      document.querySelectorAll('.cart-count-bubble span, [data-cart-count]').forEach(el => {
        el.textContent = cartData.item_count;
      });

      const cartBubble = document.querySelector('.cart-count-bubble');
      if (cartBubble && cartData.item_count > 0) {
        cartBubble.classList.remove('hidden');
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        const parser        = new DOMParser();
        const doc           = parser.parseFromString(cartDrawerHtml, 'text/html');
        const newCartDrawer = doc.querySelector('cart-drawer');

        if (newCartDrawer) {
          const newInner     = newCartDrawer.querySelector('.drawer__inner');
          const currentInner = cartDrawer.querySelector('.drawer__inner');

          if (newInner && currentInner) {
            currentInner.innerHTML = newInner.innerHTML;
          } else {
            cartDrawer.innerHTML = newCartDrawer.innerHTML;
          }

          cartDrawer.classList.remove('is-empty');
          await new Promise(resolve => setTimeout(resolve, 50));

          if (typeof cartDrawer.open === 'function') {
            cartDrawer.open(cartDrawer);
          } else {
            cartDrawer.classList.add('active');
            document.body.classList.add('overflow-hidden');
            const drawerInner = cartDrawer.querySelector('.drawer__inner');
            if (drawerInner) drawerInner.classList.add('drawer__inner--has-animation');
          }

          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartData } }));
        }
      }

      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled    = false;
        btn.classList.remove('loading');
      }, 1500);

    } catch (error) {
      console.error('Error adding to cart:', error);
      btn.textContent = 'ERROR - TRY AGAIN';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled    = false;
        btn.classList.remove('loading');
      }, 2000);
    }
  });

})();